import { useEffect } from "react";

import { mountDocumentHeadEntry } from "./lib";

interface UseDocumentHeadParams {
  /**
   * Number of `<Page>`s rendered around the calling page (from `PageDepthContext`)
   */
  depth: number;
  title: string;
  faviconUrl: string;
}

/**
 * Sets the document title and favicon while the calling component is mounted.
 *
 * It registers in an effect and unregisters in the effect's cleanup, so it stays
 * correct under StrictMode's simulated unmount/remount.
 */
export function useDocumentHead({
  depth,
  title,
  faviconUrl,
}: UseDocumentHeadParams): void {
  useEffect(
    () => mountDocumentHeadEntry({ depth, title, faviconUrl }),
    [depth, title, faviconUrl]
  );
}
